import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export function requireRoles(...allowedRoles: string[]): CanActivateFn {
  return async (_route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const account = authService.getActiveAccount();
    if (!account) {
      return router.createUrlTree(['/public']);
    }

    const roles = await authService.getRolesAsync();
    const isAllowed = roles.some(role => allowedRoles.includes(role));

    if (isAllowed) {
      const pendingLegalRoute = await authService.getPendingLegalRouteAsync();
      if (pendingLegalRoute && state.url !== pendingLegalRoute) {
        return router.createUrlTree([pendingLegalRoute]);
      }

      return true;
    }

    if (roles.includes('TeamMember')) {
      return router.createUrlTree(['/my-media']);
    }

    if (roles.some(role => ['SiteAdmin', 'OrgAdmin', 'EventPlanner'].includes(role))) {
      return router.createUrlTree(['/home']);
    }

    return router.createUrlTree(['/public']);
  };
}
